<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-if="!indicatorType">
            <!--<div style="padding-bottom: 50px">-->
            <!--<div style="background-color: white; font-size: 13px; text-align: left">-->
            <!--<div style="padding: 10px 15px 10px 15px;display: flex;flex-direction: row;align-items: center;">-->
            <!--<img class="portrait-shape portrait-size-40"-->
            <!--:src="data.userDetails ? data.userDetails[data.profileId].portraitImgUrl : ''"-->
            <!--style="margin-right: 10px">-->
            <!--<div style="display: flex;flex-direction: column">-->
            <!--<span class="title-color" style="font-size: 16px;margin-bottom: 4px">{{data.userDetails ? data.userDetails[data.profileId].realName : ''}}</span>-->
            <!--<span v-if="data.statusCd == 1"-->
            <!--class="approve-pending-color">等待审批</span>-->
            <!--<span v-else-if="data.statusCd == 2"-->
            <!--class="approve-reject-color">审批被拒绝</span>-->
            <!--<span v-else-if="data.statusCd == 3"-->
            <!--class="approve-agree-color">审批通过</span>-->
            <!--<span v-else-if="data.statusCd == 5"-->
            <!--class="approve-withdrawn-color">审批已撤回</span>-->
            <!--</div>-->
            <!--</div>-->

            <div style="padding-bottom: 60px; text-align: left">
                <div style="font-size: 14px; text-align: left; position: relative;">
                    <div class="approve-detail-head">
                        <img class="approve-detail-head--portrait"
                             :src="data.userDetails ? data.userDetails[data.profileId].portraitImgUrl : ''">
                        <div>
                            <div style="align-items: baseline">
                                <span style="font-size: 16px">{{data.userDetails ? data.userDetails[data.profileId].realName : ''}}</span>
                                <span v-if="data.statusCd == 1" style="margin-left: 10px"
                                      class="approve-pending-color">等待审批</span>
                                <span v-else-if="data.statusCd == 5" style="margin-left: 10px"
                                      class="approve-withdrawn-color">已撤回</span>
                            </div>
                            <div style="margin-top: 8px">
                                <span style="font-size: 14px;">{{data.userDetails ? data.userDetails[data.profileId].fullDepPathName : ''}}</span>
                            </div>
                            <div style="margin-top: 8px">
                                <span>审批编号：</span>
                                <span>{{data.seqNo}}</span>
                            </div>
                            <div style="position: absolute;right: 15px; top: 20px;">
                                <img v-if="data.statusCd == 2" src="../../assets/img/detail/已驳回.png"
                                     style="height: 36px">
                                <img v-if="data.statusCd == 3" src="../../assets/img/detail/已通过.png"
                                     style="height: 36px">
                                <!--<img v-if="data.statusCd == 4" src="../../assets/img/detail/已驳回.png"-->
                                <!--style="height: 36px">-->
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 10px">
                        <div
                            v-for="(cmpt, i) in form"
                            :key="i">
                            <detailCompnents :cmpt="cmpt"></detailCompnents>
                        </div>
                    </div>

                </div>

                <div class="approve-detail-process">
                    <yd-timeline>
                        <yd-timeline-item v-for="(flow,i) in rules"
                                          :key="i">
                            <div
                                slot="icon" style="text-align: center; align-items: center">
                                <img class="portrait-shape portrait-size-30"
                                     :src="getProcessPortrait(flow)">
                                <div v-if="flow.remark" class="process-item-role">{{flow.remark}}</div>
                            </div>
                            <div style="padding: 9px 0px 0px 10px; min-height: 36px">
                                <div class="flow-row">
                                    <div class="flow-row-user">
                                        <span>{{getProcessName(flow)}}</span>
                                        <span class="flow-row-state"
                                              v-if="flow.type == 1">发起申请</span>
                                        <span class="flow-row-state approve-pending-color"
                                              v-else-if="flow.isNow">
                                        <span v-if="flow.actType == 'or'">或签中</span>
                                        <span v-else-if="flow.actType == 'and'">会签中</span>
                                        <span v-else>审批中</span>
                                    </span>
                                        <span class="flow-row-state approve-agree-color"
                                              v-else-if="flow.type == 2">已同意</span>
                                        <span class="flow-row-state approve-reject-color"
                                              v-else-if="flow.type == 3">已拒绝</span>
                                        <span class="flow-row-state approve-withdrawn-color"
                                              v-else-if="flow.type == 4">已撤回</span>
                                        <span class="flow-row-state"
                                              v-else-if="flow.type == 5">添加评论</span>
                                        <span class="flow-row-state"
                                              v-else-if="flow.type == 6">编辑了审批单</span>
                                    </div>
                                    <div class="flow-row-time">{{calculateWait(i)}}</div>
                                </div>
                                <div v-if="flow.actType=='or' || flow.actType=='and'"
                                     style="padding: 10px 10px 10px 10px; background-color: #f9f9f9; margin-top: 10px; width: 70%">
                                    <span v-if="flow.actType=='or'"
                                          style="color: #bbb; font-size: 12px">以下成员一人审批即可</span>
                                    <span v-else-if="flow.actType=='and'"
                                          style="color: #bbb; font-size: 12px">须以下所有人审批通过</span>
                                    <div
                                        style="display: flex; flex-direction: row; align-items: center;margin-top: 10px"
                                        v-for="(aitem, i) in flow.approvals"
                                        :key="i">
                                        <img class="portrait-shape portrait-size-30"
                                             :src="getPortrait(aitem)">
                                        <span class="flow-row-user"
                                              style="margin-left: 10px">{{getNotifierName(aitem)}}</span>
                                    </div>
                                </div>

                                <div
                                    v-if="flow.content && (!data.temp.opinionHide || !(flow.type == 2 || flow.type == 3) || (isHistoryApprover || isApprover))"
                                    class="flow-row-user"
                                    style="color: #999; margin-top: 10px">{{flow.content}}
                                </div>
                            </div>
                        </yd-timeline-item>
                    </yd-timeline>
                </div>
                <div v-if="notifiers.length > 0" style="margin-top: 15px; text-align: left">
                    <van-cell
                        title="抄送人">
                        <template slot>
                            <span v-if="noticeType=='1'">仅全部同意后通知</span>
                            <span v-else-if="noticeType=='2'">仅发起时通知</span>
                            <span v-else-if="noticeType=='3'">发起时和全部同意后均通知</span>
                        </template>
                    </van-cell>
                    <van-row
                        style="background-color: white; padding: 5px 15px 10px 15px">
                        <van-col class="upload-image" v-for="(notifier, i) in notifiers" :key=i span="4">
                            <div style="padding: 5px 0px 5px; text-align: center; height: 80px">
                                <img class="portrait-shape portrait-size-36" :src="getPortrait(notifier.value)"/>
                                <div class="ellipsis-multi-1"
                                     style="font-size: 12px; color: #596c83;padding: 0px 4px 0px 4px">
                                    {{getNotifierName(notifier.value)}}
                                </div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
            <!--<div v-if="data" class="bottom-layout">-->
            <!--<div v-if="isApprover" class="bottom-layout-btn" @click="showDialog(1)">同意</div>-->
            <!--<div v-if="isApprover" class="bottom-layout-divider"></div>-->
            <!--<div v-if="isApprover" class="bottom-layout-btn" @click="showDialog(2)">驳回</div>-->
            <!--<div v-if="isApprover" class="bottom-layout-divider"></div>-->
            <!--<div v-if="isApprover && data.nowProcess.canUpdate && editForm.length > 0" class="bottom-layout-btn"-->
            <!--@click="edit()">编辑-->
            <!--</div>-->
            <!--<div v-if="isApprover && data.nowProcess.canUpdate" class="bottom-layout-divider"></div>-->
            <!--<div v-if="isFromMe && data.statusCd == 1" class="bottom-layout-btn" @click="showDialog(3)">撤销</div>-->
            <!--<div v-if="isFromMe && data.statusCd != 5" class="bottom-layout-divider"></div>-->
            <!--<div class="bottom-layout-btn" @click="showDialog(4)">评论</div>-->
            <!--</div>-->

            <div v-if="data"
                 class="approve-detail-bottom-layout">
                <img src="../../assets/img/detail/投影.png" style="width: 100%">
                <div class="approve-detail-bottom-layout--group">
                    <div v-if="isApprover" class="bottom-layout-btn--group--common bottom-layout-btn--group--agree"
                         @click="showDialog(1)">
                        <span>同意</span>
                    </div>
                    <div v-if="isApprover" class="bottom-layout-btn--group--other onepx-v" @click="showDialog(2)">
                        <img src="../../assets/img/detail/驳回.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">驳回</div>
                    </div>
                    <div v-if="isFromMe && data.statusCd == 1" class="bottom-layout-btn--group--other onepx-v"
                         @click="showDialog(3)">
                        <img src="../../assets/img/detail/撤销.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">撤销</div>
                    </div>
                    <div v-if="isFromMe && data.statusCd != 5" class="bottom-layout-btn--group--other onepx-v"
                         @click="showDialog(4)">
                        <img src="../../assets/img/detail/评论.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">评论</div>
                    </div>
                </div>
            </div>
            <van-dialog
                v-model="dialogShow"
                show-cancel-button
                :title="dialogTitle"
                :before-close="beforeClose"
            >
                <van-field
                    style="padding-top: 15px"
                    v-if="dialogType == 1"
                    v-model="opinionAgree"
                    type="textarea"
                    :placeholder="'审批意见'"
                />
                <van-field
                    style="padding-top: 15px"
                    v-else-if="dialogType == 2"
                    v-model="opinionRefuse"
                    type="textarea"
                    :placeholder="'审批意见'"
                />
                <van-field
                    style="padding-top: 15px"
                    v-else-if="dialogType == 4"
                    v-model="opinionComment"
                    type="textarea"
                    :placeholder="'评论'"
                />
                <!--<div style="text-align: left; padding: 15px 15px 15px 15px" v-if="dialogType == 3">你确定要撤销申请吗</div>-->
            </van-dialog>
        </div>
    </div>
</template>

<script>
    import detailCompnents from './detailCompnents';
    import head from '../../mixins/head';
    import _ from '../../helper/lodash';
    import indicatorEmpty from './empty';
    import componnetInitValue from '../../mixins/component';

    export default {
        components: {
            detailCompnents,
            indicatorEmpty
        },
        name: 'approve-detail',
        mixins: [head, componnetInitValue],
        data() {
            return {
                data: '',
                form: [],
                rules: [],
                notifiers: [],
                result: {},
                isApprover: false,
                isHistoryApprover: false,
                isFromMe: false,
                dialogShow: false,
                dialogType: null,
                dialogTitle: '',
                opinionAgree: '',
                opinionRefuse: '',
                opinionComment: '',
                editForm: [],
                noticeType: '',
                indicatorType: 0,
                indicatorMessage: '',
                time: ''
            };
        },
        props: {
            data2: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        watch: {
            '$route': 'inited'
        },
        computed: {},
        created() {
            this.markRead();
        },
        mounted() {
            window.shareBtn = () => {
                let shareData = {
                    companyId: this.data.temp.companyId,
                    title: '审批：' + this.data.title || this.data.approveName,
                    content: '',
                    shareType: 'APP_URL',
                    shareUrl: window.location.href,
                    imgUrl: this.data.userDetails[this.data.profileId].portraitImgUrl
                };
                let shareContent = '';
                try {
                    shareContent += '发起人:' + this.data.userDetails[this.data.profileId].realName;
                    let showContent = JSON.parse(this.data.showContent);
                    for (let i = 0; i < showContent.length; i++) {
                        let item = showContent[i];
                        shareContent += '\n' + item.label + ':' + item.value;
                    }
                } catch (e) {
                    ;
                }
                shareData.content = shareContent;
                window.share(shareData);
            };

            window.submitAgain = () => {
                this.submitAgain();
            };
            this.inited();
        },
        methods: {

            init() {
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                } else {
                    this.getData();
                }
            },

            inited() {
                if (this.$route.name == 'approve-detail') {
                    this.setTitle(this.data.title || this.data.approveName || '详情');
                    window.moreButton({
                        btnName: '更多',
                        children: [{
                            btnName: '分享',
                            action: 'shareBtn'
                        }, {
                            btnName: '再次提交',
                            action: 'submitAgain'
                        }]
                    });
                    console.log('inited', this.time, '==>', this.$route.query.time);
                    if (this.time != this.$route.query.time) {
                        this.time = _.cloneDeep(this.$route.query.time);
                        console.log('inited time ==========>', this.time);
                        for (let key in this.$data) {
                            if (_.isArray(this.$data[key])) {
                                this.$data[key] = [];
                            } else if (_.isObject(this.$data[key])) {
                                this.$data[key] = {};
                            } else if (_.isString(this.$data[key])) {
                                this.$data[key] = '';
                            } else if (_.isInteger(this.$data[key])) {
                                this.$data[key] = 0;
                            }
                        }
                        this.getData();
                    }
                }
            },

            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                this.$http.post('badu/eaa/queryApproveDetail.do', param, { toast: true })
                    .then((response) => {
                        this.$toast.clear();
                        this.data = response.data;
                        this.noticeType = this.data.temp.noticeType;
                        this.initData();
                    })
                    .catch((error) => {
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                    });
            },

            markRead() {
                this.$http.post('badu/eaa/notifyNotifyMeApproveIsRead.do', { ids: this.$route.query.id })
                    .then((response) => {
                        console.log(response);
                    });
            },

            initData() {
                this.setTitle(this.data.title || this.data.approveName || '详情');
                let tempResult = JSON.parse(this.data.content);
                let tempForm = JSON.parse(this.data.temp.form);
                this.result = tempResult;
                this.form = [];
                this.initRelate(tempForm, tempResult);
                this.initFormValue(this.form, tempForm, tempResult);
                this.editForm = [];
                for (let i = 0; i < this.form.length; i++) {
                    if (this.form[i].props.edit) {
                        this.editForm.push(this.form[i]);
                    }
                }
                if (this.data.temp.opinionRemind) {
                    this.opinionAgree = this.data.temp.opinionRemind;
                    this.opinionRefuse = this.data.temp.opinionRemind;
                }
                this.rules = [];
                this.rules.push(...this.data.historyProcess);
                if (this.data.nowProcess) {
                    this.data.nowProcess.isNow = true;
                    this.data.nowProcess.createdTime = '';
                    this.rules.push(this.data.nowProcess);
                }
                if (this.data.futureProcess) {
                    for (let i = 0; i < this.data.futureProcess.length; i++) {
                        let a = this.data.futureProcess[i];
                        a.createdTime = '';
                        a.isFuture = true;
                        this.rules.push(a);
                    }
                }
                this.notifiers = [];
                this.notifiers.push(...this.data.notifiers);
                this.isApprover = this.isApproverMethod();
                this.isHistoryApprover = this.isHistoryApproverMethod();
                this.isFromMe = this.isFromMeMethod();
            },

            getProcessPortrait(rule) {
                try {
                    if (rule.approvals) {
                        if (rule.approvals.length == 1) {
                            console.log('getProcessPortrait', rule, this.data.userDetails[rule.approvals[0]]);
                            return this.data.userDetails[rule.approvals[0]].portraitImgUrl;
                        } else if (rule.approvals.length > 1) {
                            if (rule.actType == 'or') {
                                return require('../../assets/img/icon/duoren.png');
                            } else if (rule.actType == 'and') {
                                return require('../../assets/img/icon/duoren.png');
                            }
                        }
                    }
                } catch (e) {
                    console.log('getProcessPortrait', e);
                }
                //默认
                return require('../../assets/img/default_portrait.png');
            },

            getPortrait(profileId) {
                try {
                    return this.data.userDetails[profileId].portraitImgUrl;
                } catch (e) {
                    return require('../../assets/img/default_portrait.png');
                }
            },

            getNotifierName(profileId) {
                try {
                    if (profileId == this.$store.state.userInfo.profileId) {
                        return '我';
                    }
                    return this.data.userDetails[profileId].realName;
                } catch (e) {
                    return '';
                }
            },

            getProcessName(rule) {
                if (rule.approvals) {
                    if (rule.approvals.length == 1) {
                        return this.getNotifierName(rule.approvals[0]);
                    } else if (rule.approvals.length > 1) {
                        if (rule.isNow) {
                            return rule.approvals.length + '人';
                        } else if (rule.actType == 'or') {
                            return rule.approvals.length + '人或签';
                        } else if (rule.actType == 'and') {
                            return rule.approvals.length + '人会签';
                        }
                    }
                }
                return '请选择';
            },

            calculateWait(i) {
                if (this.rules[i].isNow) {
                    let msDiff;
                    if (this.rules[i - 1].createdTime) {
                        // return moment(this.rules[i - 1].createdTime).fromNow();
                        msDiff = new Date().getTime() - this.rules[i - 1].createdTime;
                    } else {
                        msDiff = new Date().getTime() - this.data.createdTime;
                    }
                    // return moment(this.data.createdTime).fromNow();
                    return '已等待 ' + this.diffTime(msDiff);
                } else if (this.rules[i].createdTime) {
                    return moment(this.rules[i].createdTime).format('MM.DD HH:mm');
                }
                return '';
            },

            diffTime(msDiff) {
                let seconds = Math.floor(msDiff / 1000);
                if (seconds < 60) {
                    return '不到1分钟';
                }
                let minutes = Math.floor(seconds / 60);
                if (minutes < 60) {
                    return minutes + '分钟';
                }
                let hours = Math.floor(minutes / 60);
                if (hours < 24) {
                    return hours + '小时' + minutes % 60 + '分钟';
                }
                return Math.floor(hours / 24) + '天' + hours % 24 + '小时';
            },

            isApproverMethod() {
                let exist = false;
                let profileId = this.$store.state.userInfo.profileId;
                console.log('isApprover', profileId);
                if (this.data.statusCd == 1) {
                    for (let i = 0; i < this.data.nowProcess.approvals.length; i++) {
                        if (profileId == this.data.nowProcess.approvals[i]) {
                            exist = true;
                            break;
                        }
                    }
                }
                return exist;
            },

            isHistoryApproverMethod() {
                let exist = false;
                let profileId = this.$store.state.userInfo.profileId;
                console.log('isHistoryApprover', profileId);
                for (let i = 0; i < this.data.historyProcess.length; i++) {
                    let item = this.data.historyProcess[i];
                    if (item.type == '2' || item.type == '3' || item.type == '6') {
                        for (let j = 0; j < item.approvals.length; j++) {
                            if (profileId == item.approvals[j]) {
                                exist = true;
                                break;
                            }
                        }
                    }
                }
                return exist;
            },

            isFromMeMethod() {
                return this.data.profileId == this.$store.state.userInfo.profileId;
            },

            showDialog(type) {
                this.dialogShow = true;
                this.dialogType = type;
                switch (type) {
                    case 1:
                        this.dialogTitle = '同意申请';
                        break;
                    case 2:
                        this.dialogTitle = '驳回申请';
                        break;
                    case 3:
                        this.dialogTitle = '你确定要撤销申请吗';
                        break;
                    case 4:
                        this.dialogTitle = '添加评论';
                        break;
                }
            },

            recall() {
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                this.$http.post('badu/eaa/recallApproveMoving.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '撤销成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            agree() {
                if (this.data.temp.opinionRequired && !this.opinionAgree.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写审批意见'
                    });
                    return;
                }
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    nodeSort: this.data.currentNodeSort,
                    reason: this.opinionAgree
                };
                this.$http.post('badu/eaa/agreeApproveMoving.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionAgree = this.data.temp.opinionRemind;
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '同意成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            refuse() {
                if (this.data.temp.opinionRequired && !this.opinionRefuse.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写审批意见'
                    });
                    return;
                }
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    nodeSort: this.data.currentNodeSort,
                    reason: this.opinionRefuse
                };
                this.$http.post('badu/eaa/refuseApproveMoving.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionRefuse = this.data.temp.opinionRemind;
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '驳回成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            comment() {
                if (!this.opinionComment.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写评论内容'
                    });
                    return;
                }
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    nodeSort: this.data.currentNodeSort,
                    content: this.opinionComment
                };
                this.$http.post('badu/eaa/commentApproveMoving.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionComment = '';
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '评论成功'
                        });
                        this.getData();
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            beforeClose(action, done) {
                if (action === 'confirm') {
                    done();
                    switch (this.dialogType) {
                        case 1:
                            this.agree();
                            break;
                        case 2:
                            this.refuse();
                            break;
                        case 3:
                            this.recall();
                            break;
                        case 4:
                            this.comment();
                            break;
                    }
                    // setTimeout(done, 1000);
                    this.dialogType = '';
                } else {
                    done();
                    this.dialogType = '';
                }
            },

            edit() {
                window.tempForm = _.cloneDeep(this.editForm);
                window.tempData = _.cloneDeep(this.result);
                this.PUSH({
                    name: 'approve-create',
                    query: { id: this.data.approveId, title: this.data.title, detailId: this.data.id, isEdit: true }
                });
            },

            submitAgain() {
                window.tempData = _.cloneDeep(this.result);
                window.tempTitle = _.cloneDeep(this.data.title || this.data.approveName);
                this.PUSH({
                    name: 'approve-create',
                    query: { id: this.data.approveId, title: this.data.approveName, isAgain: true }
                });
            }

        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-detail.scss';

    .flow-row {
        display: flex;
        flex-direction: row;
        /*align-items: start;*/ //这种写法打包报错，改成下面写法
        align-items: flex-start;
        color: #596c83;
    }

    .flow-row-user {
        font-size: 14px;
        flex: 1;
    }

    .flow-row-state {
        font-size: 14px;
        margin-left: 10px;
        flex-grow: 1;
    }

    .flow-row-time {
        font-size: 13px;
        color: #a4afbc;
    }

    .process-item-role {
        width: 60px;
        padding: 4px 2px 4px 2px;
        font-size: 12px;
        line-height: 14px;
        color: white;
        transform: scale(0.5, 0.5);
        border-radius: 4px;
        overflow: hidden;
        background-color: #3388ff;
        position: absolute;
        top: 18px;
        left: -15px;
    }

    .bottom-layout {
        position: fixed;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background-color: white;
        height: 45px;
        flex-direction: row;
        display: flex;
        align-items: center
    }

    .bottom-layout-btn {
        flex: 1;
        line-height: 45px;
        color: #3388ff;
        font-size: 15px
    }

    .bottom-layout-divider {
        border-left: 1px #eee solid;
        height: 20px
    }

</style>
